// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_ifb","cls2":"SimplePaperPodcast-cls2_2Te SimplePaperPodcast-cls1_ifb"};